/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OfferContactResponse } from '../../models/offer-contact-response';

export interface GetOfferContacts$Params {
  id: number;
}

export function getOfferContacts(http: HttpClient, rootUrl: string, params: GetOfferContacts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OfferContactResponse>>> {
  const rb = new RequestBuilder(rootUrl, getOfferContacts.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OfferContactResponse>>;
    })
  );
}

getOfferContacts.PATH = '/offers/{id}/contacts';
